export const CHARACTERS = {
  astridStormweaver: {
    prototypeId: 'astridStormweaver',
    name: "Astrid Stormweaver",
    rarity: 5,
    level: 1,
    maxLevel: 10,
    type: "Cosmic Valkyrie Commander",
    stats: {
      hp: 21373,
      attack: 1865,
      defense: 810,
      speed: 240,
      criticalRate: 5,
      criticalDamage: 4213
    },
    skills: [],
    tags: ["Cosmic", "Valkyrie"],
    elements: ["light", "nature"],
    ascensionBonuses: [
      { level: 1, name: "Cosmic Awakening", bonus: { stat: "all", increase: 0.05 } },
      { level: 2, name: "Stellar Might", pullsRequired: 3, bonus: { stat: "all", increase: 0.05 } },
      { level: 3, name: "Cosmic Mastery", pullsRequired: 7, bonus: { stat: "all", increase: 0.05 } },
      { level: 4, name: "Valkyrie's Resolve", pullsRequired: 15, bonus: { stat: "all", increase: 0.05 } },
      { level: 5, name: "Astral Resonance", pullsRequired: 25, bonus: { stat: "all", increase: 0.05 } }
    ]
  },
  loki: {
    prototypeId: 'loki',
    name: "Loki",
    rarity: 4,
    type: "Master of Deception",
    level: 1,
    maxLevel: 10,
    stats: {
      hp: 18450,
      attack: 2105,
      defense: 645,
      speed: 260,
      criticalRate: 10,
      criticalDamage: 4213
    },
    skills: [],
    tags: ["Trickster", "Shadow"],
    elements: ["shadow"],
    ascensionBonuses: [
      { level: 1, name: "Shadow Walker", bonus: { stat: "all", increase: 0.05 } },
      { level: 2, name: "Deceptive Strike", pullsRequired: 3, bonus: { stat: "all", increase: 0.05 } },
      { level: 3, name: "Master Illusionist", pullsRequired: 7, bonus: { stat: "all", increase: 0.05 } },
      { level: 4, name: "Trickster's Might", pullsRequired: 15, bonus: { stat: "all", increase: 0.05 } },
      { level: 5, name: "Shadow Mastery", pullsRequired: 25, bonus: { stat: "all", increase: 0.05 } }
    ]
  },
  sindriStarforge: {
    prototypeId: 'sindriStarforge',
    name: "Sindri Starforge",
    rarity: 3,
    type: "Support Smith",
    level: 1,
    maxLevel: 10,
    stats: {
      hp: 15780,
      attack: 1450,
      defense: 920,
      speed: 200,
      criticalRate: 3,
      criticalDamage: 3505
    },
    skills: [],
    tags: ["Smith", "Support"],
    elements: ["fire"],
    ascensionBonuses: [
      { level: 1, name: "Smith's Wisdom", bonus: { stat: "all", increase: 0.05 } },
      { level: 2, name: "Master's Defense", pullsRequired: 2, bonus: { stat: "all", increase: 0.05 } },
      { level: 3, name: "Forge Master", pullsRequired: 5, bonus: { stat: "all", increase: 0.05 } },
      { level: 4, name: "Artisan's Vitality", pullsRequired: 10, bonus: { stat: "all", increase: 0.05 } },
      { level: 5, name: "Divine Craft", pullsRequired: 20, bonus: { stat: "all", increase: 0.05 } }
    ]
  }
};

export const ENEMIES = {
  loki: {
    prototypeId: 'loki',
    name: "Loki",
    type: "Master of Deception",
    level: 1,
    stats: {
      hp: 18450,
      attack: 2105,
      defense: 645,
      speed: 260,
      criticalRate: 10,
      criticalDamage: 4213
    },
    skills: [],
    tags: ["Trickster", "Shadow"],
    elements: ["shadow"]
  },
}